import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";
import * as Sentry from "@sentry/react-router";
import { startTransition, StrictMode } from "react";

if (window.ENV?.BUGSINK_DSN) {
  Sentry.init({
    dsn: window.ENV.BUGSINK_DSN,
    environment: window.ENV.SENTRY_ENVIRONMENT,
    release: window.ENV.APP_VERSION,
    tracesSampleRate: 0,
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications",
      "Non-Error promise rejection captured",
      /AbortError/,
      /Failed to fetch/i,
      /Load failed/i,
    ],
  });
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>
  );
});
